<template>
  <li class="flex items-center justify-between space-x-2 py-4">
    <div>
      <h4 class="text-text-neutral-primary text-base font-semibold">
        {{ name }}
      </h4>
      <p class="text-text-neutral-tertiary text-sm">{{ text }}</p>
    </div>
    <img
      class="shrink-0"
      src="../../../assets/images/chevron-arrow-light.svg"
      width="24"
      height="24"
      alt=""
    />
  </li>
</template>

<script setup lang="ts">
  defineProps<{
    name: string;
    text: string;
  }>();
</script>
